import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=519f0fca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=519f0fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f0fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519f0fca')) {
      api.createRecord('519f0fca', component.options)
    } else {
      api.reload('519f0fca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=519f0fca&scoped=true&", function () {
      api.rerender('519f0fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCKjbZwQ5SMt/JS/comp/PopupBox.vue"
export default component.exports